import { Switch } from '@cfa/react-components';
import React from 'react';
import styled from 'styled-components';

interface Props {
  id: string;
  isToggledPromoFree?: boolean;
  togglePromoFreeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PromoFreeToggle: React.FC<Props> = ({ id, isToggledPromoFree = false, togglePromoFreeHandler }) => (
  <StyledPromoFreeToggle className="promo-free-box">
    <p className="promo-free-text">Promo Free</p>
    <Switch checked={isToggledPromoFree} data-testid="toggle" id={id} onChange={togglePromoFreeHandler} />
  </StyledPromoFreeToggle>
);

const StyledPromoFreeToggle = styled.div`
  & .promo-free-text {
    margin-right: 8px;
    color: ${(props) => props.theme.colors.text};
    font: ${(props) => props.theme.regularTextFont};
  }
`;

export default PromoFreeToggle;
// --------------------------------------------------
